import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const TileViewGlyph = /*#__PURE__*/createElement("g", {
  id: "tile_view"
}, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("rect", {
  x: "36.5",
  y: "26.5",
  className: "st9",
  width: "11.5",
  height: "11.5"
}), /*#__PURE__*/createElement("rect", {
  x: "36.5",
  y: "46.5",
  className: "st9",
  width: "11.5",
  height: "11.5"
}), /*#__PURE__*/createElement("rect", {
  x: "55.5",
  y: "26.5",
  className: "st9",
  width: "11.5",
  height: "11.5"
}), /*#__PURE__*/createElement("rect", {
  x: "17.5",
  y: "26.5",
  className: "st9",
  width: "11.5",
  height: "11.5"
}), /*#__PURE__*/createElement("rect", {
  x: "17.5",
  y: "46.5",
  className: "st9",
  width: "11.5",
  height: "11.5"
})));
const TileView = createSvg({
  name: 'tile_view',
  path: TileViewGlyph
});

export default TileView;
export { TileViewGlyph };
